import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import { useSession, signIn } from 'next-auth/react';
import { ApolloProvider } from '@apollo/client';
import MainLayout from '@layouts/main';
import { useIgnoreAuth } from '@lib/hooks/useIgnoreAuth';

export const createApolloClient = (token: string) => {
  return new ApolloClient({
    link: new HttpLink({
      uri:
        token != null
          ? `${process.env.NEXT_PUBLIC_API_BASE}/graphql`
          : `${process.env.NEXT_PUBLIC_API_BASE}/guest/graphql`,
      credentials: 'same-origin',
      headers:
        token != null
          ? {
              authorization: `Bearer ${token}`,
            }
          : {},
    }),
    cache: new InMemoryCache({
      typePolicies: {
        Person: {
          keyFields: ['darn'],
        },
      },
    }),
  });
};

export const ApolloProviderWrapper: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const { data: session, status } = useSession();
  const { preventSignIn } = useIgnoreAuth();

  const apolloClient = useMemo(
    () => createApolloClient(session?.accessToken),
    [session?.accessToken]
  );

  if (!preventSignIn) {
    if (status === 'unauthenticated') {
      void signIn('da');
    }
    if (status !== 'authenticated') {
      return (
        <MainLayout
          alignment="top"
          panelled={false}
          restrictWidth={true}
          showSpinner
        />
      );
    }
  }

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
